import React from 'react'

import { isTierFilterAvailable } from 'Pods/SearchPage/Shared/PriceContent/constants'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import PlanChip from './Components/PlanChip/PlanChip'
import WishListChip from './Components/WishListChip/WishListChip'

// Callers mount this only after hydration: usePageConfig can already hold the config on the first
// client render, and showing the chips then would mismatch the server markup. Tracking reports the
// caller's event_source, so callers must wrap it in a FilterTrackingProvider.
function PersonalChips() {
  const pageConfig = usePageConfig()

  const planTier = isTierFilterAvailable(pageConfig) && pageConfig.isActiveSubscriber
    ? pageConfig.subscriptionTier
    : undefined
  const hasWishListItems = !!pageConfig?.hasWishListItems

  if (!planTier && !hasWishListItems) return null

  return (
    <>
      {planTier && <PlanChip tier={planTier} />}
      {hasWishListItems && <WishListChip />}
    </>
  )
}

export default PersonalChips
